import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FiltersStateHistoryEngine } from "./type";

const initialState: FiltersStateHistoryEngine = {
  fromDate: null,
  toDate: null,
};

const filtersSliceHistoryEngine = createSlice({
  name: "filters",
  initialState,
  reducers: {
    setFromDate(state, action: PayloadAction<Date | null>) {
      state.fromDate = action.payload;
    },
    setToDate(state, action: PayloadAction<Date | null>) {
      state.toDate = action.payload;
    },
  },
});

export const { setFromDate, setToDate } = filtersSliceHistoryEngine.actions;
export default filtersSliceHistoryEngine.reducer;
